import React, { useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {CssBaseline, Container} from "@mui/material";
import Header from "./UI/Frame";
import Auth from "./routes/authenticate";
import Settings from "./routes/dashboard";
import { Start } from "./routes/index";
import Found from "./routes/found";
import { Stage } from "./routes/stage";
import Finance from "./routes/finance";
import Rentals from "./routes/rentals";
import Hearts from "./routes/hearts";
import Agent from "./routes/agent";
import { Agency } from "./routes/agency";
import { Calculate } from "./routes/calculate";
import News from "./routes/news";
import Privacy from "./routes/privacy";

const PREFIX = 'App';

const classes = {
  app: `${PREFIX}-app`,
  root: `${PREFIX}-root`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.app}`]: {
    //backgroundColor: theme.palette.background.default,
  },

  [`& .${classes.root}`]: {
    //paddingTop: 24,
    backgroundColor: theme.palette.background.paper,
    flexDirection: "column",
    color: "rgb(54, 54, 54)",
    //textAlign: "center",
    [theme.breakpoints.down("md")]: {
      minHeight: isStaged() ? "100vh" : "calc(100vh - 109px)",
    },
    [theme.breakpoints.up("md")]: {
      minHeight: isStaged() ? "100vh" : "calc(100vh - 134px)",
    },
    //display: "flex",
    //justifyContent: "center",
    //alignItems: "center",
    overflow: "auto",
  }
}));

const isStaged = () => {
  return window.location.pathname.indexOf("stage") > 0;
};

const _App = () => {

  const [love, makeLove] = useState(false);
  //Make love if it does not exist
  if (!localStorage.getItem("love")) {
    localStorage.setItem("love", "");
  }

  let lovers = localStorage["love"].split(",").length > 1;
  useEffect(() => {
    if (lovers) {
      makeLove(true);
    }
  }, [lovers]);
  return (
    <Root className={classes.app}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path={`${process.env.PUBLIC_URL}/stage/:home/`} element={<Stage makeLove={makeLove} />} />
        </Routes>
        {!isStaged() && <Header love={love} />}
        {!isStaged() && (
          <Container className={classes.root + " App-container"}>
            <Routes>
              <Route exact path={`${process.env.PUBLIC_URL}/`} element={<Start makeLove={makeLove} />} />
              <Route path={`${process.env.PUBLIC_URL}/rentals`} element={<Rentals makeLove={makeLove} />} />
              <Route path={`${process.env.PUBLIC_URL}/hearts`} element={<Hearts makeLove={makeLove} />} />
              <Route path={`${process.env.PUBLIC_URL}/agent/:agent/agency/:agency`} element={<Agent makeLove={makeLove} />} />
              <Route path={`${process.env.PUBLIC_URL}/agency/:agency`} element={<Agency makeLove={makeLove} />} />
              <Route path={`${process.env.PUBLIC_URL}/finance`} element={<Finance />} />
              <Route path={`${process.env.PUBLIC_URL}/calculate`} element={<Calculate />} />
              <Route path={`${process.env.PUBLIC_URL}/news`} element={<News />} />
              <Route path={`${process.env.PUBLIC_URL}/privacy`} element={<Privacy />} />
              <Route path={`${process.env.PUBLIC_URL}/found/:home/:agent`} element={<Found makeLove={makeLove} />} />
              <Route path={`${process.env.PUBLIC_URL}/found/:home/`} element={<Found makeLove={makeLove} />} />
              <Route path={`${process.env.PUBLIC_URL}/auth`} element={<Auth />} />
              <Route path={`${process.env.PUBLIC_URL}/dashboard`} element={<Settings makeLove={makeLove} />} />
            </Routes>
          </Container>
        )}
      </Router>
    </Root>
  );
};

export const App = _App;
